import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input} from '@angular/core';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DataService } from "../services/data.service";
import { CommonService } from '../services/common.service';
import { APIService } from './../api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'accounts-group-pref.component',
  templateUrl: './accounts-group-pref.component.html',
  styleUrls: ['./accounts-group-pref.component.scss']
})
export class AccountsGroupPrefComponent implements OnInit{
  settingsArray: Array<{ con: string, headName: string, headID: number }> = [
    { con: 'Customer', headName: 'all', headID: 0 },
    { con: 'Supplier', headName: 'all', headID: 0 }
  ];

  @Input() mdlRef: any;
  @Input() context: string = '';
  @Input() GrpID: any = 0;
  selectedHead: any = null;
  jarvisData: any = [];
  agencyData: any = []
  CustGrpPrefs: any = []
  isClosSettingShow = false
  heads: any = [];
  isFromLink: any=false;
  showConn: string = "";

  constructor(private activeModal: NgbActiveModal, private headService: DataService,
      private appService: DataService, private modalService: NgbModal, private apiService: APIService,
      private deviceService: DeviceDetectorService, private _Activatedroute: ActivatedRoute,
      private SpinnerService: NgxSpinnerService, public CmnService: CommonService) {}

  ngOnInit(): void{
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    let CustGrpPrefs = this.apiService.getCookie("ERP_Cfg");
    if (CustGrpPrefs) {
      this.CustGrpPrefs = JSON.parse(CustGrpPrefs);
      this.CustGrpPrefs = JSON.parse(this.CustGrpPrefs[0].CustGrpPrefs);
      this.settingsArray = this.CustGrpPrefs
    }
    this.getHeadsFromCookie();
    if(this.context == "Customer"){
      this.showConn = "customer";
      this.selectedHead = this.CustGrpPrefs.length == 0 ? 0 :  this.CustGrpPrefs[0].headID
    }
    else{
      this.showConn = "supplier"
      this.selectedHead = this.CustGrpPrefs.length == 0 ? 0 :  this.CustGrpPrefs[1].headID     
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if((urlParams.get('conn') || '') != ""){
      this.isClosSettingShow = true;
      this.isFromLink = true;
      this.context = urlParams.get('conn') || ''; 
      if(this.context == "Customer"){
        this.selectedHead = this.CustGrpPrefs.length == 0 ? 0 : this.CustGrpPrefs[0].headID
        this.showConn = "customer"
      }
      else{
        this.selectedHead = this.CustGrpPrefs.length == 0 ? 0 : this.CustGrpPrefs[1].headID    
        this.showConn = "supplier" 
      }
    }
  }
  getHeadsFromCookie(): void {
    const cookieValue = this.apiService.getCookie('Heads'); 
    if (cookieValue) {
      this.heads =  JSON.parse(cookieValue);
     }
  }
  saveChoice(): void {
    this.apiService.swalConfirm("Are you sure you want to change group?", () => {
      if (this.heads) {
        let temphead: any = []
        temphead = this.heads.filter((o: any) => o.HeadID == this.selectedHead)
        if(temphead.length == 0){
          temphead.push({HeadName: 'all', HeadID: 0 })
        }
        const savedObject = {
          con: this.context,
          headName: temphead[0].HeadName ? temphead[0].HeadName : '' ,
          headID: temphead[0].HeadID ? temphead[0].HeadID : 0
        };
        this.updateSettingsArray(savedObject);
        this.activeModal.close(savedObject);
        
        if (this.isFromLink) {
          window.close();
        }
        
      } else {
        this.apiService.successAlert('Please select a head before saving.');
      }
    }, () => {});
  }
  close() {
    if (this.mdlRef) {
      this.mdlRef.close(); 
    }
  }
  updateSettingsArray(savedObject: { con: string, headName: string, headID: number }): void {
    if(savedObject == undefined) return;
    const index = savedObject.con == 'Customer' ? 0 : 1;

    if(this.settingsArray.length != 2){
      this.settingsArray.push({ con: 'Customer', headName: 'all', headID: 0 });
      this.settingsArray.push({ con: 'Supplier', headName: 'all', headID: 0 });
    }
    this.settingsArray[index] = savedObject;
    var tempData = [{
      'ChangeType': 'CUSTGRPPREF',
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod':1,
      'PrdRejnReasons': '',
      'HSNSAC':'',
      'CategoryName': '',
      'CustGrpPrefs' : JSON.stringify(this.settingsArray)
  }]
  let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
  }];
  this.SpinnerService.show();
  this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  successEntry(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      this.apiService.successAlert(res.message);
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table2 && ErpData.Table2.length > 0) {
          let cfg = ErpData.Table2;
          let ErpCfgData = JSON.stringify(cfg);
          this.apiService.setCookie("ERP_Cfg", ErpCfgData);
        }
        this.apiService.successAlert('Default group changed saved successfully.');
      }   
    }
  }
  failureResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
  }

  confirmDeLink(acctDocLink: number) {
    this.apiService.swalConfirm(`Are you sure you want to ${acctDocLink ? 'link' : 'de-link'} the account?`, () => {
      let data = [{
        'ChangeType': 'ACCTDOCLNKD',
        'ProdIndustryIDs': '',
        'ProdSegmentIDs': '',
        'SellToIndustryIDs': '',
        'SellToSegmentIDs': '',
        'BuyFromIndustryIDs': '',
        'BuyFromSegmentIDs': '',
        'BankInfo': '',
        'GSTIN': '',
        'StgFunnelStages': '',
        'StgPrintPrefs': '',
        'Letterhead': '',
        'DigiSign': '',
        'Terms': '',
        'IMNo': '',
        'IMKey': '',
        'SenderEmail': '',
        'SenderEmailPwd': '',
        'SMSSenderID': '',
        'SMSKey': '',
        'TmplID': '',
        'RazorPayKey': '',
        'RazorPayKeySecret': '',
        'CustomePrintHeader': '',
        'CompanyLogo': '',
        'TIUserID': '0',
        'TIProfileID': '0',
        'TIKey': '',
        'BILID': '0',
        'certiType': '',
        'cin': '',
        'acctDocLinked': acctDocLink
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'cfg',
        moduleID: 13,
        data: JSON.stringify(data)
      }];

      this.SpinnerService.show();
      this.apiService.sendChange(myParams, (res: any) => {
        this.SpinnerService.hide();
        if (res.error) {
          this.apiService.successAlert(res.message);
        } else {
          // Update local data
          this.agencyData[0].AcctDocLinked = acctDocLink;
          
          // Update M cookie to persist status
          this.apiService.setCookie("M", JSON.stringify(this.agencyData));
          
          this.apiService.successAlert(`Account ${acctDocLink ? 'linked' : 'de-linked'}.
            ${acctDocLink ? 'Please configure GST ledgers from GST ledgers configuration.' : ''}`);
          this.close();
        }
      }, (err: any) => {
        this.SpinnerService.hide();
      });
    }, () => {
      // User cancelled
    });
  }
}